export default __webpack_public_path__ + "a7aa023ad7abec9ff9ad99a03c2b613e.svg";